//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionText,
  Divider,
  IconClock,
  IconSiren,
  IconTools,
  Illustration,
  Modal,
  Typography,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { COUNTRIES, MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'

import translationsTrustList from '../TrustList/TrustList.translations'

import translations from './WarrantyModal.translations'

const terms = {
  [COUNTRIES.FR]: ROUTES.PDF.TERMS_SALE,
}

export default {
  components: {
    ActionText,
    IconSiren,
    IconClock,
    IconTools,
    Divider,
    FormattedMessage,
    Illustration,
    Modal,
    Typography,
  },

  props: {
    name: {
      type: String,
      default: MODAL_NAMES.REASSURANCE.WARRANTY,
    },
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      country: 'config/country',
      warrantyDuration: 'config/warrantyDuration',
      isLegalsInModal: 'config/cgvModalLegals',
    }),

    termsLocation() {
      return {
        name: terms[this.country] || ROUTES.PDF.TERMS_USE,
      }
    },

    warrantyLocation() {
      return {
        name: ROUTES.PDF.WARRANTY,
      }
    },

    isGermany() {
      return this.country === COUNTRIES.DE
    },

    showFirstLine() {
      return this.$t(translations.pointOneTitle)
    },

    showSecondLine() {
      return this.$t(translations.pointTwoTitle)
    },

    showThirdLine() {
      return this.$t(translations.pointThreeTitle)
    },

    title() {
      return this.$t(translationsTrustList.warranty, {
        warrantyDuration: this.warrantyDuration,
      })
    },
  },
}
